































import { Component, Vue } from 'vue-property-decorator';
import {
  BookingCutoffOptions,
  CancellationPolicyOptions,
  RefundablePolicyOptions,
} from '@/models';
import { formatDuration, intervalToDuration } from 'date-fns';
import { offerModule } from '@/store/modules/moduleOffer';

@Component
export default class OfferEditPolicy extends Vue {
  private cancellationType = 0 as CancellationPolicyOptions;
  private baseCancellationType = 0 as CancellationPolicyOptions;
  private refundable = 0 as RefundablePolicyOptions;
  private baseRefundable = 0 as RefundablePolicyOptions;
  private bookingCutoff = 0 as BookingCutoffOptions;
  private baseBookingCutoff = 0 as BookingCutoffOptions;
  private cancelCutoff = '';
  private bookingCutoffBefore = '';
  private cancellationCutoff = {
    days: 0,
    hours: 0,
    minutes: 0,
  };
  private bookingCutoffTimes = {
    days: 0,
    hours: 0,
    minutes: 0,
  };
  private baseCancellationCutoff = {
    days: 0,
    hours: 0,
    minutes: 0,
  };
  private baseBookingCutoffTimes = {
    days: 0,
    hours: 0,
    minutes: 0,
  };

  get Offer() {
    return offerModule.Offer;
  }

  mounted() {
    this.configureCancelPolicy();
  }

  convertMinutesToTimes(timeMinutes: number) {
    const day = 24 * 60;
    const days = timeMinutes / day;
    const daysR = timeMinutes % day;
    const hours = daysR / 60;
    const hoursR = daysR % 60;
    return {
      days: days,
      hours: hours,
      minutes: hoursR,
    };
  }

  configureCancelPolicy() {
    const policy = this.Offer?.policy;
    if (!policy) {
      return;
    }

    this.refundable = policy.refundable
      ? RefundablePolicyOptions.YES
      : RefundablePolicyOptions.NO;
    this.baseRefundable = policy.refundable
      ? RefundablePolicyOptions.YES
      : RefundablePolicyOptions.NO;
    if (policy.cancellable) {
      this.cancellationType = CancellationPolicyOptions.YES;
      this.baseCancellationType = CancellationPolicyOptions.YES;
      if (policy.cutOffTime && policy.cutOffTime > 0) {
        this.cancelCutoff = formatDuration(
          intervalToDuration({ start: 0, end: policy.cutOffTime * 1000 * 60 }),
          { format: ['days', 'hours', 'minutes'], delimiter: ', ' },
        );
        const cancelCutoff = this.convertMinutesToTimes(policy.cutOffTime || 0);
        this.cancellationCutoff = cancelCutoff;
        this.baseCancellationCutoff = cancelCutoff;
      }
    } else if (!policy.cancellable) {
      this.cancellationType = CancellationPolicyOptions.NO;
      this.baseCancellationType = CancellationPolicyOptions.NO;
    }

    if (policy.cutOffTime) {
      this.bookingCutoff = BookingCutoffOptions.YES;
      this.baseBookingCutoff = BookingCutoffOptions.YES;
      this.bookingCutoffBefore = formatDuration(
        intervalToDuration({ start: 0, end: policy.cutOffTime * 1000 * 60 }),
        { format: ['days', 'hours', 'minutes'], delimiter: ', ' },
      );
    } else {
      this.bookingCutoff = BookingCutoffOptions.NO;
    }
  }
}
